import React from 'react';
import { Mail, MapPin, Linkedin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import LanguageSelector from './LanguageSelector';
import { linkedinCompanyUrl } from '../data/interview';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_cc896aae-282d-4475-9628-943e35aab3be/artifacts/d085f74a_Business%20Club%20France%20Latvia_SSa-R00a_Mil.png';

const Footer = () => {
  const { t } = useLanguage();

  const navLinks = [
    { id: 'mission', label: t.nav.mission },
    { id: 'services', label: t.nav.services },
    { id: 'fonctionnement', label: t.nav.process },
    { id: 'faq', label: t.nav.faq },
    { id: 'contact', label: t.nav.contact },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1a1c1b] border-t border-[#3f4816]/30 py-12 md:py-16">
      <div className="max-w-[87.5rem] mx-auto px-6 md:px-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Logo & Tagline */}
          <div className="lg:col-span-2">
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="flex items-center gap-3 mb-4 group"
            >
              <img 
                src={LOGO_URL} 
                alt="Business Club France Latvia" 
                className="h-14 w-auto object-contain group-hover:opacity-80 transition-opacity"
              />
            </button>
            <p className="text-[#888680] text-sm mb-6 max-w-sm">
              {t.footer.tagline}
            </p>
            <LanguageSelector />
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[#d9fb06] font-semibold text-sm uppercase tracking-wider mb-4">
              Navigation
            </h4>
            <nav className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="text-[#888680] text-sm font-medium hover:text-[#d9fb06] transition-colors text-left"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-[#d9fb06] font-semibold text-sm uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="space-y-4">
              <a
                href="mailto:info@bcfl.eu"
                className="flex items-center gap-3 text-[#888680] text-sm hover:text-[#d9fb06] transition-colors"
              >
                <Mail className="w-4 h-4 text-[#d9fb06]" />
                info@bcfl.eu
              </a>
              <div className="flex items-start gap-3 text-[#888680] text-sm">
                <MapPin className="w-4 h-4 text-[#d9fb06] flex-shrink-0 mt-0.5" />
                <span>{t.footer.address}</span>
              </div>
              <a
                href={linkedinCompanyUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin-link"
                className="inline-flex items-center gap-3 text-[#888680] text-sm hover:text-[#d9fb06] transition-colors"
              >
                <Linkedin className="w-4 h-4 text-[#d9fb06]" fill="currentColor" strokeWidth={0} />
                LinkedIn
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#3f4816]/30 pt-8">
          <p className="text-[#888680] text-xs text-center">
            {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
